<div class="flex min-h-dvh flex-col md:flex-row md:h-dvh md:overflow-hidden">
  <!-- Mobile header with image (visible only on mobile) -->
  <div
    class="md:hidden h-[25vh] min-h-[150px] bg-login_account bg-cover"
    style="background-position: 30% center;"
  ></div>

  <!-- Left side: Image (desktop only) -->
  <div
    class="hidden md:flex md:w-1/2 lg:w-3/5 relative overflow-hidden"
  >
    <div
      class="absolute inset-0 bg-login_account bg-cover"
      style="background-position: 30% center;"
    ></div>
    <!-- Copyright & links on photo -->
    <div class="absolute bottom-4 left-0 right-0 z-10 text-center">
      <div class="flex items-center justify-center gap-3 text-xs text-white/70">
        <a [href]="conditionsUrl" target="_blank" class="hover:text-white no-underline">
          {{ 'register.conditionsTooltip' | transloco }}
        </a>
        <span>·</span>
        <a [href]="privacyUrl" target="_blank" class="hover:text-white no-underline">
          {{ 'register.privacyTooltip' | transloco }}
        </a>
      </div>
      <p class="text-xs text-white/60 mt-1">
        © {{ currentYear }} Greentripper
      </p>
    </div>
  </div>

  <!-- Right side: Form -->
  <div
    class="flex-1 md:min-h-0 md:w-1/2 lg:w-2/5 flex flex-col bg-white md:shadow-xl relative md:overflow-hidden"
  >
    <!-- Language selector top right -->
    <div class="absolute top-4 right-4">
      <app-auth-header></app-auth-header>
    </div>

    <div class="flex-1 md:min-h-0 flex flex-col items-center md:justify-center px-6 py-8 md:overflow-y-auto">
      <div class="w-full max-w-sm">
        <!-- Logo above form -->
        <div class="mb-8">
          <img
            src="/assets/Logo___Greentripper_primary_horizontal_with_slogan.svg"
            alt="Greentripper - Act for Travel"
            class="h-20 w-auto"
          />
        </div>
        <router-outlet />
      </div>
    </div>
  </div>
</div>
